// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1jaKC","actionsCol":"EnrolledClinics_actionsCol__t0G9z"};